import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate1x.svg'

export const IconPlaybackRate1x = IconSVG as IconComponent
